/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IProductSearchData } from './product-search.data';
import { IProductSearchProps } from './product-search.props.autogenerated';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    Button, //getTelemetryObject,
    IModuleProps,
    ITelemetryContent, getTelemetryObject
    //INodeProps, ITelemetryContent
} from '@msdyn365-commerce-modules/utilities';
import classname from 'classnames';
import { Dropdown, IDropdownItemProps, IDropdownOnSelection } from '../../themes/adventureworks/views/components/dropdown';
import { searchByCriteriaAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { ProductLookupClause, ProductRefinerValue, ProductSearchCriteria, ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
import { ISearchResultContainerResources } from '@msdyn365-commerce-modules/search-result-container';
import { ProductSearchResultItems } from './components/product-search-result-items';
import { IImageSettings } from '@msdyn365-commerce/core';
import { generateProductImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { getFitmentFiltersDataBytypeAsync } from '../../actions/getFitmentSearchFilterData';
import { IGCFitmentSearchCriteria } from '../../actions/AlternateItemsEntity.g';
import { getItemIdsAsync } from '../../actions/getItemIds';
import { getAttributeInfoAsync } from '../../actions/gc-get-attributeInfo';
import { IAttributeInfo } from '../search-result-container/search-result-container';

export interface IProductSearchState {
    ProductLineState: string;
    Year: string;
    Make: string;
    Model: string;
    Keywords: string;
    YearLists: IDropdownItemProps[];
    MakeLists: IDropdownItemProps[];
    ModelLists: IDropdownItemProps[];
    SearchBtnEnable: boolean;
    isLoading: boolean;
    RefinerEnable:boolean;
    CustomRefiners: string;
}

export interface IProductSearchViewProps extends IProductSearchProps<IProductSearchData> {
    state: IProductSearchState;
    moduleProps: IModuleProps;
    productFilters?: React.ReactNode;
    productResults: React.ReactNode | undefined;
}

export interface IProductSearchCustom {
    productResults: React.ReactNode | undefined;
}

const prodLineElm = React.createRef<Dropdown>();
const yearElm = React.createRef<Dropdown>();
const makeElm = React.createRef<Dropdown>();
const modelElm = React.createRef<Dropdown>();
const keywordElm = React.createRef<HTMLInputElement>();
/**
 *
 * ProductSearch component
 * @extends {React.PureComponent<IProductSearchProps<IProductSearchData>>}
 */
@observer
class ProductSearch extends React.PureComponent<IProductSearchProps<IProductSearchData>, IProductSearchState> {


    private readonly telemetrycontent: ITelemetryContent;

    @observable private productSearchCustom: React.ReactNode;

    private _productClauses: ProductLookupClause[] = [];

    private _attributeInfo: IAttributeInfo = {};

    constructor(props: IProductSearchProps<IProductSearchData>, state: IProductSearchState) {
        super(props);
        // this.productSearchCustom = {
        //     productResults:undefined
        // };
        this.state = {
            ProductLineState: '',
            Year: '',
            Make: '',
            Model: '',
            Keywords: '',
            isLoading: false,
            YearLists: [{ id: 0, value: '' }],
            ModelLists: [{ id: 0, value: '' }],
            MakeLists: [{ id: 0, value: '' }],
            SearchBtnEnable: false,
            RefinerEnable:false,
            CustomRefiners: 'Active'
        };
        this.telemetrycontent = getTelemetryObject(this.props.context.request.telemetryPageName!, this.props.friendlyName, this.props.telemetry);

    }

    public async componentDidMount(): Promise<void> {
        let categoryId = sessionStorage.getItem('CategoryId');
        const yearId = sessionStorage.getItem('Year');
        const modelId = sessionStorage.getItem('Model');
        const makeId = sessionStorage.getItem('Make');
        if( categoryId  !== undefined && categoryId?.length === 0)
        {categoryId = '0';}
        if(categoryId)
        {
            prodLineElm.current?.setState({selectedIndex: categoryId});
            this.setState({ProductLineState:categoryId});
        }
        if(yearId && makeId)
        {
            this.setState({isLoading:true});
            const searchCriteria: IGCFitmentSearchCriteria = { CategoryId: categoryId??'0',Year: yearId,Make: makeId, CallType: 'ALL' };
            var allFiltersData = await getFitmentFiltersDataBytypeAsync({ callerContext: this.props.context.actionContext }, searchCriteria);
            console.log(allFiltersData);
            if(allFiltersData && allFiltersData.length > 0)
            {
                const allFilters = allFiltersData[0];
                 const yearLst: IDropdownItemProps[] = [{ id: '0', value: '' }];
                    allFilters.YearLst && allFilters.YearLst.forEach(function (item: any, idx: any) {
                        const currentYr: IDropdownItemProps = { id: item, value: item };
                        yearLst.push(currentYr);
                    });
                    if (yearLst) {
                        this.setState({YearLists: yearLst, Year: yearId});
                        yearElm.current?.setState({selectedIndex: yearId});
                    }
                const makeFiltered: IDropdownItemProps[] = [{ id: '0', value: '' }];
                    allFilters.MakeLst && allFilters.MakeLst.forEach(function (item: any, idx: any) {
                        const currentMake: IDropdownItemProps = { id: item.trim(), value: item.trim() };
                        makeFiltered.push(currentMake);
                    });
                    if (makeFiltered) {
                        this.setState({ MakeLists: makeFiltered, Make: makeId.trim() });
                        makeElm.current?.setState({selectedIndex: makeId.trim()});
                    }
                const modelFiltered: IDropdownItemProps[] = [{ id: '0', value: '' }];
                    allFilters.ModelLst && allFilters.ModelLst.forEach(function (item: any, idx: any) {
                        const currentModel: IDropdownItemProps = { id: item.trim(), value: item.trim() };
                        modelFiltered.push(currentModel);
                    });
                    if (modelFiltered) {
                        this.setState({ ModelLists: modelFiltered, Model: (modelId && modelId.trim())?? '' });
                modelElm.current?.setState({selectedIndex: (modelId && modelId.trim()) ?? ''});
                    }

            this._enableSearchButton();
            await this._onSearchClick();
            }
        }
        else{
            if(yearId)
            {
                this.setState({isLoading:true});
                const searchCriteria: IGCFitmentSearchCriteria = { CategoryId: categoryId??'0', CallType: 'YEAR' };
                var yearFilterData = await getFitmentFiltersDataBytypeAsync({ callerContext: this.props.context.actionContext }, searchCriteria);
                if (yearFilterData && yearFilterData.length > 0) {
                    const yearLst: IDropdownItemProps[] = [{ id: '0', value: '' }];
                    yearFilterData.forEach(function (item: any, idx: any) {
                        const currentYr: IDropdownItemProps = { id: item.Year, value: item.Year };
                        yearLst.push(currentYr);
                    });
                    if (yearLst) {
                        this.setState({ YearLists: yearLst });
                    }

                }
                this.setState({Year: yearId});
                yearElm.current?.setState({selectedIndex: yearId});
            }
            if(makeId && yearId)
            {
                const searchCriteria: IGCFitmentSearchCriteria = { CategoryId: categoryId??'0', Year: yearId, CallType: 'MAKE' };
                var makeFilterData = await getFitmentFiltersDataBytypeAsync({ callerContext: this.props.context.actionContext }, searchCriteria);
                if (makeFilterData && makeFilterData.length > 0) {
                    const makeFiltered: IDropdownItemProps[] = [{ id: '0', value: '' }];
                    makeFilterData.forEach(function (item: any, idx: any) {
                        const currentMake: IDropdownItemProps = { id: item.Make.trim(), value: item.Make.trim() };
                        makeFiltered.push(currentMake);
                    });
                    if (makeFiltered) {
                        this.setState({ MakeLists: makeFiltered });
                    }
                }
                this.setState({Make: makeId.trim()});
                makeElm.current?.setState({selectedIndex: makeId.trim()});
            }
            if(modelId && makeId && yearId)
            {
                const searchCriteria: IGCFitmentSearchCriteria = { CategoryId: categoryId??'0', Year: this.state.Year, Make: makeId, CallType: 'MODEL' };
                var modelFilterData = await getFitmentFiltersDataBytypeAsync({ callerContext: this.props.context.actionContext }, searchCriteria);
                if (modelFilterData && modelFilterData.length > 0) {
                    const modelFiltered: IDropdownItemProps[] = [{ id: '0', value: '' }];
                    modelFilterData.forEach(function (item: any, idx: any) {
                        const currentModel: IDropdownItemProps = { id: item.Model.trim(), value: item.Model.trim() };
                        modelFiltered.push(currentModel);
                    });
                    if (modelFiltered) {
                        this.setState({ ModelLists: modelFiltered });
                    }
                }
                this.setState({Model: modelId.trim()});
                modelElm.current?.setState({selectedIndex: modelId.trim()});
            this._enableSearchButton();
            await this._onSearchClick();
            }
        }
        this.setState({isLoading:false});
        if(!yearId)
        {
            void this._getYears();
        }
    }

    public render(): JSX.Element | null {

        const viewProps: IProductSearchViewProps = this.getProductSearchProps();
        return this.props.renderView(viewProps);
    }

    private readonly getProductSearchProps = (): IProductSearchViewProps => {
        // const {
        //     resources: { backToShopping, orderDetailsBuyItemsAgainHeaderText },
        //     config: { heading }
        // } = this.props;
        const moduleProps = { moduleProps: this.props, className: classname('ms-product-search', this.props.config.className) };


        return {
            ...this.props,
            moduleProps,
            productFilters: this._renderProductFilters(),
            state: this.state,
            productResults: this.productSearchCustom
        };
    };

    private readonly _renderProductFilters = () => {
        const { categories } = this.props.data;
        const dropdownList: IDropdownItemProps[] = [{ id: 0, value: 'All' }];
        if (categories && categories !== null && categories.result && categories.result.length > 0) {
            for (const cat of categories.result) {
                dropdownList.push({ value: cat.Name ?? '', id: cat.RecordId });
                if (cat.Children && cat.Children.length > 0) {
                    for (const childCat of cat.Children) {
                        dropdownList.push({ value: `--${childCat.Name?? ''}`, id: childCat.RecordId });
                    }
                }
            }
        }

        return (
            <>
                <div className="msc-product-search-form">
                    <div className="msc-product-search-form__item">
                        <label className="msc-product-search-form__label">Product Line </label>
                        <Dropdown
                            className="msc-product-search-form__dropdown"
                            dropdownId={1}
                            dropdownName={"Product Line"}
                            dropdownList={dropdownList}
                            onChange={this._onProductLineChange}
                            ref={prodLineElm}
                        //onChange={this._onDimensionChanged}
                        />
                    </div>
                    <div className="msc-product-search-form__item">
                        <label className="msc-product-search-form__label">Year </label>
                        <Dropdown className="msc-product-search-form__dropdown" dropdownId={2} dropdownName='Year' dropdownList={this.state.YearLists} ref={yearElm} onChange={this._onYearChange} />
                    </div>
                    <div className="msc-product-search-form__item">
                        <label className="msc-product-search-form__label">Make </label>
                        <Dropdown className="msc-product-search-form__dropdown" dropdownId={3} dropdownName='Make' dropdownList={this.state.MakeLists} ref={makeElm} onChange={this._onMakeChange} />
                    </div>
                    <div className="msc-product-search-form__item">
                        <label className="msc-product-search-form__label">Model </label>
                        <Dropdown className="msc-product-search-form__dropdown" dropdownId={4} dropdownName='Model' dropdownList={this.state.ModelLists} ref={modelElm} onChange={this._onModelChange} />
                    </div>
                    <div className="msc-product-search-form__item">
                        <label className="msc-product-search-form__label"></label>
                        <Button id="Search" title='Search' disabled={!this.state.SearchBtnEnable} className="msc-product-search-form__button-search msc-btn" onClick={this._onSearchClick}>Search</Button>
                        <Button id="Clear" title='Reset Search' className="msc-product-search-form__button-clear msc-btn" onClick={this._onClearClick}>Reset Search</Button>
                    </div>
                    <div className="msc-product-search-form__item">
                    { this.state.RefinerEnable &&
                        <div className='ms-feature-search-result__list'><span><label>Active<input type='radio' onChange={this._onChangeActiveFilter} name='ActiveFilter' value={'Active'} checked={this.state.CustomRefiners === 'Active'} /></label></span>
                        <span><label>Inactive<input type='radio' onChange={this._onChangeActiveFilter} name='ActiveFilter' value='Inactive' checked={this.state.CustomRefiners === 'Inactive'}/></label></span><span><label>All<input onChange={this._onChangeActiveFilter} type='radio' name='ActiveFilter' value='All' checked={this.state.CustomRefiners === 'All'}/></label></span></div>
                    }
                    </div>
                </div>
                {this.state.isLoading ? <div className='ms-order-upload__loading' id='loading' >Loading...</div> : <div></div>}
            </>

        );
    };

    private getProductSearch = async (products: ProductSearchResult[]): Promise<void> => {
        const elm = await this._renderSearchProducts(products);
        // this.productSearchCustom.productResults = (<></>);
        this.productSearchCustom = elm;
    };

    private readonly _renderSearchProducts = async (products: ProductSearchResult[]): Promise<JSX.Element> => {
        const res: ISearchResultContainerResources = {
            noResultsForRefinersText: 'No products found for the selected criteria.',
            resultCategoryNotFoundText: 'No products found for the selected category',
            resultSearchNotFoundText: 'No products found for the given search term',
            paginationAriaLabel: 'Page navigation example',
            priceFree: 'Free',
            priceRangeSeparator: ' - ',
            originalPriceText: 'Original price',
            currentPriceText: 'Current price',
            ratingAriaLabel: 'Average {0} of {1} stars',
            flipperNext: 'flipperNext config value',
            flipperPrevious: 'flipperPrevious config value',
            searchTextPrefix: 'Results for ',
            numberOfProducts: '{0} products',
            oneProduct: '1 product',
            categoryLinkAriaLabel: 'Go To:',
            choiceAriaLabel: '',
            choiceFormat: '',
            choiceRangeValueFormat: '',
            choiceSummaryLabel: '',
            clearAllText: '',
            closeAriaLabel: '',
            featureSimilarDescriptionTitle: '',
            featureSimilarLooksTitle: '',
            maxLabel: '',
            maxValueSliderThumbAriaLabel: '',
            minLabel: '',
            minValueSliderThumbAriaLabel: '',
            modalCloseButtonText: '',
            modalTitle: '',
            placeholderTextMax: '',
            productCountAriaLabel: '',
            rangeNameFormat: '',
            refineItemAriaLabel: '',
            refineItemsAriaLabel: '',
            singleProductCountAriaLabel: '',
            sortByDropdownLabel: '',
            sortByOptionBestSelling: '',
            sortByOptionNameAsc: '',
            sortByOptionNameDesc: '',
            sortByOptionNewScore: '',
            sortByOptionPriceAsc: '',
            sortByOptionPriceDesc: '',
            sortByOptionRatingDesc: '',
            sortByOptionRelevanceDesc: '',
            sortByOptionTrendingScore: '',
            swatchItemAriaLabel: '',
            validationErrorNotNumber: '',
            validationErrorNotRange: ''
        };
        // let { imageSettings } = this.props.config;
        // if(!imageSettings)
        // {
        const imgSetgs: IImageSettings = {
            disableLazyLoad: false,
            lazyload: true,
            quality: 80,
            viewports: {
                xs: {
                    h: 295,
                    q: "w=295&h=295&q=80&m=6&f=jpg",
                    qe: "t=w295h295qhigh",
                    w: 295
                },
                xl: {
                    h: 295,
                    q: "w=295&h=295&q=80&m=6&f=jpg",
                    qe: "t=w295h295qhigh",
                    w: 295
                },
                lg: {
                    h: 295,
                    q: "w=295&h=295&q=80&m=6&f=jpg",
                    qe: "t=w295h295qhigh",
                    w: 295
                }
            }
        };
        let customerInfo;
        try {
            customerInfo = this.props.data.customerInformation?.result;
        } catch (error) {
            this.props.telemetry.debug('Unable to receive Customer Information. May be user is not authorized');
        }
        // }
        return (
            <ProductSearchResultItems
                products={products}
                context={this.props.context}
                moduleId={this.props.id}
                moduleType={this.props.typeName}
                resources={res}
                allowBackNavigation={false}
                telemetryContent={this.telemetrycontent}
                quickviewSlot={undefined}
                channelInventoryConfigurationId={undefined}
                isPriceMinMaxEnabled={undefined}
                productsDimensionAvailabilities={undefined}
                isPriceVisible={customerInfo ? true : false}
                imageSettings={imgSetgs}
                OnClick={this.onProductClick}
            />
        );
    };

    private _onProductLineChange = async (event: IDropdownOnSelection): Promise<void> => {
        this._productClauses = [];
        this.setState({ ProductLineState: event.selectId });
        this.setState({ isLoading: true });
        this.setState({RefinerEnable: false});
        const searchCriteria: IGCFitmentSearchCriteria = { CategoryId: event.selectId, CallType: 'YEAR' };
        try {
            var fitmentData = await getFitmentFiltersDataBytypeAsync({ callerContext: this.props.context.actionContext }, searchCriteria);
            if (fitmentData && fitmentData.length > 0) {
                const yearLst: IDropdownItemProps[] = [{ id: '0', value: '' }];
                fitmentData.forEach(function (item: any, idx: any) {
                    const currentYr: IDropdownItemProps = { id: item.Year, value: item.Year };
                    yearLst.push(currentYr);
                });
                if (yearLst) {
                    this.setState({ YearLists: yearLst });
                    if (yearElm && yearElm.current) {
                        yearElm.current.setState({ selectedIndex: '0' });
                    }
                }

            }
            else {
                this.setState({ YearLists: [] });
                if (yearElm && yearElm.current) {
                    yearElm.current.setState({ selectedIndex: '0' });
                }
            }
            this.setState({ ModelLists: [] });
            this.setState({ MakeLists: [] });
            if (modelElm && modelElm.current) {
                modelElm.current.setState({ selectedIndex: '' });
            }
            if (makeElm && makeElm.current) {
                makeElm.current.setState({ selectedIndex: '' });
            }
            this.setState({ isLoading: false });
        }
        catch (e) {
            console.log(e);
        }
    };

    private _onYearChange = async (event: IDropdownOnSelection): Promise<void> => {
        this._productClauses = [];
        this.setState({ Year: event.selectId });
        this.setState({ isLoading: true });
        this.setState({RefinerEnable: false});
        const searchCriteria: IGCFitmentSearchCriteria = { CategoryId: '0', Year: event.selectId, CallType: 'MAKE' };
        if (this.state.ProductLineState && this.state.ProductLineState.length > 0) {
            searchCriteria.CategoryId = this.state.ProductLineState.toString();
        }
        try {
            var fitmentData = await getFitmentFiltersDataBytypeAsync({ callerContext: this.props.context.actionContext }, searchCriteria);
            if (fitmentData && fitmentData.length > 0) {
                const makeFiltered: IDropdownItemProps[] = [{ id: '0', value: '' }];
                fitmentData.forEach(function (item: any, idx: any) {
                    const currentMake: IDropdownItemProps = { id: item.Make.trim(), value: item.Make.trim() };
                    makeFiltered.push(currentMake);
                });
                if (makeFiltered) {
                    this.setState({ MakeLists: makeFiltered });
                    if (makeElm && makeElm.current) {
                        makeElm.current.setState({ selectedIndex: '0' });
                    }
                }
            }
            else {
                this.setState({ MakeLists: [] });
                if (makeElm && makeElm.current) {
                    makeElm.current.setState({ selectedIndex: '0' });
                }
            }
            this.setState({ ModelLists: [] });
            if (modelElm && modelElm.current) {
                modelElm.current.setState({ selectedIndex: '' });
            }
            this.setState({ isLoading: false });
        }
        catch (e) {
            console.log(e);
        }
        setTimeout(this._enableSearchButton, 1000);
        // this._enableSearchButton();
    };

    private _enableSearchButton = () => {
        let isYearSelected = false;
        let isMakeSelected = false;
        let isModelSelected = false;
        if (yearElm && yearElm.current && yearElm.current.state.selectedIndex !== '0' && yearElm.current.state.selectedIndex.length > 0) {
            isYearSelected = true;
        }
        if (makeElm && makeElm.current && makeElm.current.state.selectedIndex !== '0' && makeElm.current.state.selectedIndex.length > 0) {
            isMakeSelected = true;
        }
        if (modelElm && modelElm.current && modelElm.current.state.selectedIndex !== '0' && modelElm.current.state.selectedIndex.length > 0) {
            isModelSelected = true;
        }
        if (isMakeSelected && isModelSelected && isYearSelected) {
            this.setState({ SearchBtnEnable: true });
        }
        else {
            this.setState({ SearchBtnEnable: false });
        }
    };
    private _onMakeChange = async (event: IDropdownOnSelection): Promise<void> => {
        this._productClauses = [];
        this.setState({ Make: event.selectId });
        this.setState({RefinerEnable: false});
        this.setState({ isLoading: true });
        const searchCriteria: IGCFitmentSearchCriteria = { CategoryId: '0', Year: this.state.Year, Make: event.selectId, CallType: 'MODEL' };
        if (this.state.ProductLineState && this.state.ProductLineState.length > 0) {
            searchCriteria.CategoryId = this.state.ProductLineState.toString();
        }
        try {
            var fitmentData = await getFitmentFiltersDataBytypeAsync({ callerContext: this.props.context.actionContext }, searchCriteria);
            if (fitmentData && fitmentData.length > 0) {
                const modelFiltered: IDropdownItemProps[] = [{ id: '0', value: '' }];
                fitmentData.forEach(function (item: any, idx: any) {
                    const currentModel: IDropdownItemProps = { id: item.Model.trim(), value: item.Model.trim() };
                    modelFiltered.push(currentModel);
                });
                if (modelFiltered) {
                    this.setState({ ModelLists: modelFiltered });
                    if (modelElm && modelElm.current) {
                        modelElm.current.setState({ selectedIndex: '0' });
                    }
                }

            }
            else {
                this.setState({ ModelLists: [] });
                if (modelElm && modelElm.current) {
                    modelElm.current.setState({ selectedIndex: '0' });
                }
            }

            this.setState({ isLoading: false });
        }
        catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
        }
        // this._enableSearchButton();
        setTimeout(this._enableSearchButton, 1000);
    };

    private _onModelChange = (event: IDropdownOnSelection) => {
        this._productClauses = [];
        this.setState({ Model: event.selectId });
        this.setState({RefinerEnable: false});
        // this._enableSearchButton();
        setTimeout(this._enableSearchButton, 1000);
    };

    private _onSearchClick = async (): Promise<void> => {
        let isyearBlank: boolean = false, ismakeBlank: boolean = false, ismodelBlank: boolean = false;
        if (yearElm && yearElm.current) {
            if (yearElm.current.state.selectedIndex === '0' || yearElm.current.state.selectedIndex.length === 0) {
                isyearBlank = true;
            }
        }
        if (makeElm && makeElm.current) {
            if (makeElm.current.state.selectedIndex === '0' || makeElm.current.state.selectedIndex.length === 0) {
                ismakeBlank = true;
            }
        }
        if (modelElm && modelElm.current) {
            if (modelElm.current.state.selectedIndex === '0' || modelElm.current.state.selectedIndex.length === 0) {
                ismodelBlank = true;
            }
        }
        if (isyearBlank && ismakeBlank && ismodelBlank) {
            this.productSearchCustom = (<><div className="alert alert-danger">Please select Year, Make and Model parameter values.</div></>);
        }
        else if (isyearBlank && ismakeBlank) {
            this.productSearchCustom = (<><div className="alert alert-danger">Please select Year and Make parameter values.</div></>);
        }
        else if (ismodelBlank && ismakeBlank) {
            this.productSearchCustom = (<><div className="alert alert-danger">Please select Make and Model parameter values.</div></>);
        }
        else if (isyearBlank) {
            this.productSearchCustom = (<><div className="alert alert-danger">Please select Year parameter values.</div></>);
        }
        else if (ismakeBlank) {
            this.productSearchCustom = (<><div className="alert alert-danger">Please select Make parameter values.</div></>);
        }
        else if (ismodelBlank) {
            this.productSearchCustom = (<><div className="alert alert-danger">Please select Model parameter values.</div></>);
        }
        else {
            this.setState({ isLoading: true, CustomRefiners: 'Active' });
            const { catalogId, channelId } = this.props.context.request.apiSettings;

            if (this._attributeInfo.RecId === undefined) {
                await this._getAttributeInfo("Active");
            }
            const categoryId = prodLineElm.current?.state.selectedIndex.trim();
            const searchCriteria: IGCFitmentSearchCriteria = { CategoryId: categoryId === '' ? '0' : categoryId, Year: yearElm.current?.state.selectedIndex.trim(), Make: makeElm.current?.state.selectedIndex.trim(), Model: modelElm.current?.state.selectedIndex.trim(), Keyword: keywordElm.current?.value };
            const itemIds = await getItemIdsAsync({ callerContext: this.props.context.actionContext }, searchCriteria);

            if (itemIds && itemIds.length > 0) {
                const productClauses:ProductLookupClause[]=new Array();
                for(var i=0; i< itemIds.length; i++)
                {
                    const prodClause:ProductLookupClause = {ItemId: itemIds[`${i}`].ItemId};
                    productClauses.push(prodClause);
                }

                this._productClauses = productClauses;

                const criteria: ProductSearchCriteria = {
                    Context: { CatalogId: catalogId, ChannelId: channelId },
                    ItemIds: productClauses,
                    IncludeAttributes: true,
                    Refinement: []
                };
                var productSearchResults = await searchByCriteriaAsync({ callerContext: this.props.context.actionContext }, criteria);
                if (productSearchResults && productSearchResults.length > 0) {

                    const activeItems = productSearchResults.filter((item: ProductSearchResult,idx: number) =>{
                        const activeProperty = item.AttributeValues && item.AttributeValues.filter(prop => prop.KeyName === 'Active');
                        if(activeProperty && activeProperty.length > 0 && activeProperty[0].IntegerValue && activeProperty[0].IntegerValue > 0){
                            return item;
                        }
                        return false;
                    });

                    const inActiveItems = productSearchResults.filter((item: ProductSearchResult, idx: number) => {
                        const inActiveProperty = item.AttributeValues && item.AttributeValues.filter(prop => prop.KeyName === 'Active');
                        if (!inActiveProperty || (inActiveProperty && inActiveProperty.length === 0) || (inActiveProperty && inActiveProperty.length > 0 && (!inActiveProperty[0].IntegerValue || (inActiveProperty[0].IntegerValue && inActiveProperty[0].IntegerValue === 0)))) {
                            return item;
                        }
                        return false;
                    });
                    if ((activeItems && activeItems.length > 0) || (inActiveItems && inActiveItems.length > 0)) {
                        productSearchResults = [];
                        if (activeItems && activeItems.length > 0) {
                            activeItems.forEach(val => productSearchResults.push(val));
                        }
                        if (inActiveItems && inActiveItems.length > 0) {
                            inActiveItems.forEach(val => productSearchResults.push(val));
                        }
                    }
                    const productSearchResultsWithImages = productSearchResults.map(productSearchResult => {
                        const newImageUrl = generateProductImageUrl(
                            productSearchResult,
                            this.props.context.actionContext.requestContext.apiSettings
                        );

                        if (newImageUrl) {
                            productSearchResult.PrimaryImageUrl = newImageUrl;
                        }

                        return (productSearchResult);
                    });
                    void this.getProductSearch(productSearchResultsWithImages);
                }
                else {
                    this.productSearchCustom = (<><div className="alert alert-danger">No Products match your vehicle selection.</div></>);
                }
                this.setState({ isLoading: false });
                this.setState({RefinerEnable: true});
            }
            else {
                this.setState({ isLoading: false });
                this.productSearchCustom = (<><div className="alert alert-danger">No Products match your vehicle selection.</div></>);
            }

        }

    };

    private onProductClick = (event: React.MouseEvent<HTMLElement>) : void =>{
                sessionStorage.setItem('CategoryId',prodLineElm.current?.state.selectedIndex??'');
                sessionStorage.setItem('Year',yearElm.current?.state.selectedIndex??'');
                sessionStorage.setItem('Make',makeElm.current?.state.selectedIndex??'');
                sessionStorage.setItem('Model',modelElm.current?.state.selectedIndex??'');
                sessionStorage.setItem('SearchKeyword',keywordElm.current?.value??'');

    };

    private _onChangeActiveFilter = async (event: any): Promise<void> => {

         this.setState({ CustomRefiners: event.target.value });

        const { catalogId, channelId } = this.props.context.request.apiSettings;

        let activeFilter: ProductRefinerValue = {};

        if (event.target.value !== 'All') {
            activeFilter = {
                DataTypeValue: this._attributeInfo.DataType,
                LeftValueBoundString: event.target.value === 'Active' ? '1' : '0',
                RefinerRecordId: this._attributeInfo.RecId,
                RightValueBoundString: event.target.value === 'Active' ? '1' : '0',
                ExtensionProperties: [],
                RefinerSourceValue: 1,
                RowNumber: 0,
                SwatchColorHexCode: '',
                SwatchImageUrl: '',
                UnitText: ''
            };
        }

        const criteria: ProductSearchCriteria = {
            Context: { CatalogId: catalogId, ChannelId: channelId },
            ItemIds: this._productClauses,
            IncludeAttributes: true,
            Refinement: [activeFilter]
        };

        var productSearchResults = await searchByCriteriaAsync({ callerContext: this.props.context.actionContext }, criteria);
        if (productSearchResults && productSearchResults.length > 0) {

            const activeItems = productSearchResults.filter((item: ProductSearchResult, idx: number) => {
                const activeProperty = item.AttributeValues && item.AttributeValues.filter(prop => prop.KeyName === 'Active');
                if (activeProperty && activeProperty.length > 0 && activeProperty[0].IntegerValue && activeProperty[0].IntegerValue > 0) {
                    return item;
                }
                return false;
            });

            const inActiveItems = productSearchResults.filter((item: ProductSearchResult, idx: number) => {
                const inActiveProperty = item.AttributeValues && item.AttributeValues.filter(prop => prop.KeyName === 'Active');
                if (!inActiveProperty || (inActiveProperty && inActiveProperty.length === 0) || (inActiveProperty && inActiveProperty.length > 0 && (!inActiveProperty[0].IntegerValue || (inActiveProperty[0].IntegerValue && inActiveProperty[0].IntegerValue === 0)))) {
                    return item;
                }
                return false;
            });
            if ((activeItems && activeItems.length > 0) || (inActiveItems && inActiveItems.length > 0)) {
                productSearchResults = [];
                if (activeItems && activeItems.length > 0) {
                    activeItems.forEach(val => productSearchResults.push(val));
                }
                if (inActiveItems && inActiveItems.length > 0) {
                    inActiveItems.forEach(val => productSearchResults.push(val));
                }
            }
            const productSearchResultsWithImages = productSearchResults.map(productSearchResult => {
                const newImageUrl = generateProductImageUrl(
                    productSearchResult,
                    this.props.context.actionContext.requestContext.apiSettings
                );

                if (newImageUrl) {
                    productSearchResult.PrimaryImageUrl = newImageUrl;
                }

                return (productSearchResult);
            });
            void this.getProductSearch(productSearchResultsWithImages);
        }
        else {
            this.productSearchCustom = (<><div className="alert alert-danger">No Products match your vehicle selection.</div></>);
        }
        // this.setState({ isLoading: false });
    };

    private _onClearClick = (): void => {
        if (prodLineElm && prodLineElm.current) {
            prodLineElm.current.setState({ selectedIndex: '0' });
        }
        if (yearElm && yearElm.current) {
            yearElm.current.setState({ selectedIndex: '0' });
        }
        if (makeElm && makeElm.current) {
            makeElm.current.setState({ selectedIndex: '0' });
        }
        if (modelElm && modelElm.current) {
            modelElm.current.setState({ selectedIndex: '0' });
        }
        if (keywordElm && keywordElm.current) {
            keywordElm.current.value = '';
        }

        this.setState({
            Keywords: '',
            Make: '',
            Model: '',
            Year: '',
            ProductLineState: '',
            RefinerEnable:false,
            SearchBtnEnable: false
        });
        sessionStorage.removeItem('CategoryId');
        sessionStorage.removeItem('Year');
        sessionStorage.removeItem('Make');
        sessionStorage.removeItem('Model');
        sessionStorage.removeItem('SearchKeyword');
        this.productSearchCustom = (<></>);
    };

    private _getYears = async (): Promise<void> => {
        const searchCriteria: IGCFitmentSearchCriteria = { CategoryId: '0', CallType: 'YEAR' };
        try {
            this.setState({ isLoading: true });
            var fitmentData = await getFitmentFiltersDataBytypeAsync({ callerContext: this.props.context.actionContext }, searchCriteria);
            if (fitmentData && fitmentData.length > 0) {
                const yearLst: IDropdownItemProps[] = [{ id: '0', value: '' }];
                fitmentData.forEach(function (item: any, idx: any) {
                    const currentYr: IDropdownItemProps = { id: item.Year, value: item.Year };
                    yearLst.push(currentYr);
                });
                if (yearLst) {
                    this.setState({ YearLists: yearLst });
                    if (yearElm && yearElm.current) {
                        yearElm.current.setState({ selectedIndex: '0' });
                    }
                }

            }
            this.setState({ isLoading: false });
        }
        catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
        }
    };

    private readonly _getAttributeInfo = async (attributeName: string): Promise<void> => {

        const result = await getAttributeInfoAsync({ callerContext: this.props.context.actionContext }, attributeName);

        const attributeInfo: IAttributeInfo = {};
        attributeInfo.Name = result.gcAttributeInfo?.Name;
        attributeInfo.AttributeGroupId = result.gcAttributeInfo?.AttributeGroupId;
        attributeInfo.DataType = result.gcAttributeInfo?.DataType;
        attributeInfo.LowerBound = result.gcAttributeInfo?.LowerBound;
        attributeInfo.UpperBound = result.gcAttributeInfo?.UpperBound;
        attributeInfo.RecId = result.gcAttributeInfo?.RecId;

        this._attributeInfo = attributeInfo;
    };

}

export default ProductSearch;
